import React from "react";
import Button from "../../../../Button";

const CinefanCardDetail = () => {
    return <>
        <Button block to="/usuario/wallet/comprar/cinefan" className="mb-5">
            Comprar otra tarjeta Cinefan
        </Button>
    </>;
};

export default CinefanCardDetail;
